import {
  BEBOT_ROLLOUT_CONTAINER,
  BEBOT_ROLLOUT_CIRCLE,
  BEBOT_ROLLOUT_TEXT,
  BEBOT_ROLLOUT_CLOSE_BUTTON,
} from '../widgetClassNames';

export { rolloutAnimation, closeRolloutAnimation, adjustRolloutAfterResize } from './animations';
export { default as getRolloutWidth } from './calculateWidth';

import { Button, Div, Span } from '../utils';
import design from './design';

const {
  rolloutContainer,
  rolloutCircle,
  rolloutCarret,
  rolloutButtonStyle,
  rolloutTextStyle,
  rolloutCloseButton,
} = design;

function Rollout({ backgroundColor, align, messageText, dismissText, onClick, onDismiss }) {
  return Div(
    {
      class: BEBOT_ROLLOUT_CONTAINER,
      style: rolloutContainer(!backgroundColor ? undefined : backgroundColor, align),
    },
    [
      Div({
        class: BEBOT_ROLLOUT_CIRCLE,
        style: rolloutCircle,
      }),
      Div({
        class: BEBOT_ROLLOUT_CIRCLE,
        style: rolloutCircle,
      }),
      Div({
        class: BEBOT_ROLLOUT_CIRCLE,
        style: rolloutCircle,
      }),
      Button(
        {
          type: 'button',
          class: BEBOT_ROLLOUT_TEXT,
          style: rolloutButtonStyle,
          events: {
            click: onClick,
          },
        },
        Span({ style: rolloutTextStyle }, document.createTextNode(messageText))
      ),
      Div({
        class: '',
        style: rolloutCarret(!backgroundColor ? undefined : backgroundColor, align),
      }),
      Button(
        {
          type: 'button',
          class: BEBOT_ROLLOUT_CLOSE_BUTTON,
          style: rolloutCloseButton,
          translate: 'no',
          events: {
            click: onDismiss,
          },
          'aria-label': dismissText,
        },
        document.createTextNode('×')
      ),
    ]
  );
}

export default Rollout;
